import React, { FC } from 'react';
import { MenuItem } from '@mui/material';
import { paymentAcceptanceMethodOptions } from '@efacity/common';
import { FormInputTextProps, FormTextInput } from './FormTextInput';

export const PaymentAcceptanceMethodSelector: FC<FormInputTextProps> = ({ name, required }) => {
  return (
    <FormTextInput name={name} label="Payment Acceptance Method" select required={required}>
      {paymentAcceptanceMethodOptions.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </FormTextInput>
  );
};
